import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Continuous monitoring post \nticket resolution",
  subtitle: "Network operations demo",
  text: "Ensuring customer delight with accurate \nresults from the beginning.",
  label: { iconPath: "start.png", text: "LO Automations" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_215"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_213"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 11_R1.mp4",
  pageNumber: "ILO_214",
};

export default DATA_NO_DEMO_ILO2;
